import { useEffect } from 'react';

import { EVENT_CONSTRUCTOR_READY_TO_RENDER } from '@/constants/events';
import { useAppDispatch } from '@/features/hooks';
import { rootActions } from '@/features/store';
import useMounted from '@/hooks/useMounted';
import sendEvent from '@/utils/sendEvent';

type Props = {
  isReady?: boolean;
  onReady?: () => void;
};

/**
 * Хук использующийся для выполнения обработчика
 * при готовности страницы
 */
const usePageReady = ({ onReady, isReady = true }: Props) => {
  const isMounted = useMounted();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isReady && isMounted.current.mounted) {
      dispatch(rootActions.installation.setPageReady(true));
      sendEvent(EVENT_CONSTRUCTOR_READY_TO_RENDER);
      onReady?.();
    }
  }, [isReady]);
};

export default usePageReady;
